export default "__VITE_ASSET__CyaPe184__"